import React from 'react';
import QuestionHandler from './mp-quiz-question-type-handlers/mp-quiz-ques-handler';

function QuestionHandlerHome({ params }) {
  return <QuestionHandler params={params} />;
}
export default QuestionHandlerHome;
